import React from 'react';
import Switch from '../../Switch';

const StepCapabilities = ({ project, setProject }) => {
  return (
    <div>
      <div className="text-base mb-4">Enable Capabilities for your Project.</div>
      <p className="mb-4 text-[12px]">
        The situational awareness feature will give users the option to share their live location
        from within the Salt application. If enabled their location will be shared to the command
        and control centre where assigned administrators can view their location.
      </p>
      <div className="flex items-center p-4 bg-secondary-light border border-solid border-[#E7E7E7]">
        <div>
          <div className="text-base/normal block">Situational Awareness</div>
          <div className="text-[12px] block text-[#434B58]/60">
            Users can submit reports to the C&C centre.
          </div>
        </div>
        <Switch
          sizeClass="w-9 h-5 after:h-6 after:w-6"
          className="ml-auto mr-2"
          value={project.situational_awareness_enabled}
          onClick={() =>
            setProject({
              ...project,
              situational_awareness_enabled: !project.situational_awareness_enabled,
            })
          }
        />
      </div>
      <br />
      <br />
      <p className="mb-4 text-[12px]">
        The SMART feature will give users within the project the ability to submit reports on
        specific categories, these report categories can be set once enabled. Once enabled users
        within this Project will see an additional ‘tab’ within the Salt application.
      </p>
      <div className="flex items-center p-4 bg-secondary-light border border-solid border-[#E7E7E7]">
        <div>
          <div className="text-base/normal block">SMART (Secure Messaging and Reporting Tool)</div>
          <div className="text-[12px] block text-[#434B58]/60">
            Users can submit report categories which can be viewed in the C&C centre.
          </div>
        </div>
        <Switch
          sizeClass="w-9 h-5 after:h-6 after:w-6"
          className="ml-auto mr-2"
          value={project.smart_enabled}
          onClick={() =>
            setProject({
              ...project,
              smart_enabled: !project.smart_enabled,
            })
          }
        />
      </div>
    </div>
  );
};

export default StepCapabilities;
